export type MonkeSale = {
	txid: string; inscription_id: string; block_timestamp: number; block_height: number
	price_sats: number; marketplace: number; signals: number; sighash: number
	inscriptions_in_tx?: number; seller_address?: string | null; buyer_address?: string | null
}

// Deliberately an ask-sale series, not an all-sales price index. A fee-address
// match alone (signals=16) also appears on vault locks and release transfers.
// A single-item ACP listing fill has stronger evidence. Excluded bid fills
// remain visible in activity; no arbitrary price cutoff is applied here.
export function isMonkeAskSale(sale: MonkeSale) {
	return Number.isFinite(sale.price_sats) && sale.price_sats > 0 &&
		(sale.sighash === 0x81 || sale.sighash === 0x83) &&
		(sale.signals & 1) !== 0 && sale.marketplace !== 6 &&
		sale.inscriptions_in_tx === 1 &&
		!(sale.seller_address && sale.seller_address === sale.buyer_address)
}

export function buildMonkeAskSeries(sales: MonkeSale[], start: number, end: number, bucketSeconds: number) {
	const buckets = new Map<number, { sum: number; count: number }>()
	const seen = new Set<string>()
	for (const sale of sales) {
		const key = `${sale.txid}:${sale.inscription_id}`
		if (seen.has(key) || !isMonkeAskSale(sale) || sale.block_timestamp < start || sale.block_timestamp >= end) continue
		seen.add(key)
		const time = Math.floor(sale.block_timestamp / bucketSeconds) * bucketSeconds
		const bucket = buckets.get(time) || { sum: 0, count: 0 }
		bucket.sum += sale.price_sats; bucket.count++
		buckets.set(time, bucket)
	}
	return [...buckets].sort(([a], [b]) => a - b).map(([time, bucket]) => ({ time, vwap: bucket.sum / bucket.count / 1e8 }))
}
